module.exports = __webpack_public_path__ + "VIPM10.png?9701e9cd1cc1daf561ac395a5ace1dcb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM10.png
// module id = 144
// module chunks = 0